import React from "react";
import {
  SFTypography,
  SFIcons,
  SFStack,
  SFContent,
  SFHelpers,
  SFAvatarMenu,
} from "@sf-core";

import PlayButton from "./playButton";

import { useTranslation } from "react-i18next";

const BasicDetails = ({
  item,
  enrollHandler,
  getNextCourseHandler,
  showAvatar = false,
  subTitle,
  getDropDownActions = () => {},
}) => {
  const { t } = useTranslation();
  const {
    id,
    name,
    description,
    status,
    totalCourses,
    skillPaths,
    completedSkillPaths,
    completedCourses,
    totalDuration,
    completedDuration,
  } = item;

  return (
    <SFStack spacing={4}>
      <SFStack spacing={2}>
        <SFStack alignItems="flex-start">
          {showAvatar ? (
            <SFAvatarMenu
              showAvatar={showAvatar}
              getDropDownActions={getDropDownActions}
              title={name}
              subTitle={subTitle}
            />
          ) : (
            <SFTypography variant="detailsPageHeading">{name}</SFTypography>
          )}
        </SFStack>
        <PlayButton
          itemId={id}
          status={status}
          completedDuration={completedDuration}
          totalDuration={totalDuration}
          completedCourses={completedCourses}
          totalCourses={totalCourses}
          enrollHandler={enrollHandler}
          getNextCourseHandler={getNextCourseHandler}
          totalSkillsPaths={skillPaths}
          completedSkillPaths={completedSkillPaths}
        />
      </SFStack>
      <SFContent scrollable maxLines={4}>
        {description}
      </SFContent>
      <SFStack spacing={6} direction="row">
        <SFStack direction="row" spacing={1} alignItems="center">
          <SFIcons.SFTimerIcon size={"large"} color="grey200" />
          <SFStack direction="row" spacing={1} alignItems="baseline">
            <SFTypography variant="detailsTotal">
              {SFHelpers.DurationFormatter(
                totalDuration,
                SFHelpers.DurationFormatterOptions.HOURS_ONLY
              )}
            </SFTypography>
            <SFTypography variant="detailsTotalDescription">
              {t("lxpComponents.basicDetails.estimatedHours")}
            </SFTypography>
          </SFStack>
        </SFStack>
        <SFStack direction="row" spacing={1} alignItems="center">
          <SFIcons.SFBookIcon size={"large"} color="grey200" />
          <SFStack direction="row" spacing={1} alignItems="baseline">
            <SFTypography variant="detailsTotal">{totalCourses}</SFTypography>
            <SFTypography variant="detailsTotalDescription">
              {t("lxpComponents.basicDetails.courses")}
            </SFTypography>
          </SFStack>
        </SFStack>
        {skillPaths > 0 && (
          <SFStack direction="row" spacing={1} alignItems="center">
            <SFIcons.SFMapIcon size={"large"} color="grey200" />
            <SFStack direction="row" spacing={1} alignItems="baseline">
              <SFTypography variant="detailsTotal">{skillPaths}</SFTypography>

              <SFTypography variant="detailsTotalDescription">
                {t("lxpComponents.basicDetails.skillsPaths")}
              </SFTypography>
            </SFStack>
          </SFStack>
        )}
      </SFStack>
    </SFStack>
  );
};

export default BasicDetails;
